import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@chakra-ui/react';
import adFusionLogo from '../WPP_logo_horizontal.png';
import { appThemeConfig } from 'utils/themeConfig';

const Logo = ({ ...props }) => {
  return (
    <Box {...props}>
      <img src={appThemeConfig?.meta?.sidebarLogo || adFusionLogo} />
    </Box>
  );
};

Logo.propTypes = {
  variant: PropTypes.string,
};

export default Logo;
